export type Token = {
    text: string,
    value: string,
    url: string
}

export enum TokenType {
    None,
    Lead,
    Other
}